module.exports = __webpack_public_path__ + "fonts/MTSUltraExtended-Bold.2fc6271.woff2";